import { DateController as BulletTrainDateController } from "@bullet-train/fields"

export default class extends BulletTrainDateController {
  initPluginInstance() {
    super.initPluginInstance()

    if (!this.plugin) {
      return
    }

    this.plugin.autoApply = true

    // Single-date picker selection should immediately populate the hidden ISO field.
    jQuery(this.displayFieldTarget).on("hide.daterangepicker", (_event, picker) => {
      if (!this.includeTimeValue && picker?.startDate) {
        this.applyDateToField(null, picker)
      }
    })
  }

  teardownPluginInstance() {
    if (this.pluginMainEl !== undefined) {
      jQuery(this.pluginMainEl).off("hide.daterangepicker")
    }

    super.teardownPluginInstance()
  }
}
